import styled from 'src/styles'

export const Email = styled.div`
  color: ${(props) => props.theme.palette.label.primary};
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
`
